export class disclaimerObject {
    // eslint-disable-next-line
    constructor() {
    }
    const
    getDisclaimer = (params) => {

        const {
            // eslint-disable-next-line
            financialProduct
        } = params;


        return null;
    }

}

export default disclaimerObject;